module.exports = __webpack_public_path__ + "static/media/glasschain-mra-logo.b25c730a.png";